import { forwardRef, type Ref, type SVGProps } from "react";
const IconHardHatFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M25.5 21a2.5 2.5 0 0 1 0 5h-19a2.5 2.5 0 0 1 0-5z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 6a3 3 0 0 1 2.93 2.361l.135.04v-.003l.184.056q.088.026.175.054.14.046.274.096l.154.055q.123.048.244.099l.165.068q.11.05.22.104.365.172.704.375.104.06.207.125.071.046.141.094.095.062.187.126.105.076.206.154l.125.093q.098.078.192.158a8 8 0 0 1 .306.268l.13.121q.08.078.159.158l.121.125a9 9 0 0 1 .695.83l.073.101.16.227.084.129c.56.858 1 1.827 1.323 2.88l.016.05c.466 1.536.69 3.25.69 5.056H6c0-2.9.576-5.557 1.809-7.632l.076-.13q.079-.128.162-.253l.056-.086a10 10 0 0 1 .69-.899l.067-.077q.1-.112.203-.22l.082-.085q.09-.093.184-.181l.045-.044.19-.174.042-.037a8 8 0 0 1 .522-.42l.128-.094q.111-.08.226-.154l.133-.09.21-.125.155-.093q.18-.102.367-.195l.134-.065q.132-.063.265-.123l.125-.052q.136-.058.275-.112l.168-.06q.126-.046.254-.09l.19-.058.176-.053-.001.002.135-.039q0 .008-.003.014A3 3 0 0 1 16 6m0 2a1 1 0 0 0-1 1v8a1 1 0 1 0 2 0V9a1 1 0 0 0-1-1m-4.004 2.932A6.4 6.4 0 0 0 10 12.682V16a1 1 0 1 0 2 0v-5q0-.035-.004-.068M20 11v5a1 1 0 1 0 2 0v-3.317a6.4 6.4 0 0 0-1.997-1.751z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconHardHatFilledSVG);
ForwardRef.displayName = "IconHardHatFilled";
export { ForwardRef as IconHardHatFilled };
